import React, { useState } from 'react'

import { Text } from 'marketing-site/src/library/elements/Text'
import { Modal } from 'marketing-site/src/mvp/library/elements/Modal'
import { IProps } from './index'

export const TextLink = ({
  text,
  url,
  newWindow = true,
  renderModalContent,
  modalSize = 'medium',
}: IProps): React.ReactElement => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  return (
    <div>
      {url ? (
        <a
          className="text-link"
          href={url}
          target={newWindow ? '_blank noreferrer' : ''}
          rel={newWindow ? 'noopener noreferrer' : ''}
        >
          <Text size="body">{text}</Text>
        </a>
      ) : (
        renderModalContent && (
          <>
            <button className="text-link" onClick={() => setOpenModal(true)} type="button">
              <Text size="body">{text}</Text>
            </button>
            <Modal size={modalSize} isOpen={openModal} onClose={() => setOpenModal(false)}>
              {renderModalContent()}
            </Modal>
          </>
        )
      )}
      <style jsx>
        {`
          .text-link {
            display: inline;
            color: inherit;
            text-decoration: none;
            border-bottom: 1px solid;
            &:hover,
            &:focus {
              outline: none;
              cursor: pointer;
            }
          }
        `}
      </style>
    </div>
  )
}
